import { useSelector } from "react-redux";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { usePublicSession } from "../context/PublicSessionContext";

export const useSubscriptionAccess = () => {
  const authUser = useAuthUser();
  const { user = {} } = authUser ?? {};
  const { isPublicView } = usePublicSession() ?? {};
  const hasSubscription = useSelector((state) => state.user.hasSubscription);
  const hasUsedFreeTrial = useSelector((state) => state.user.hasUsedFreeTrial);
  const subscriptionChecked = useSelector(
    (state) => state.user.subscriptionChecked,
  );
  const role = String(user?.role ?? "").toLowerCase();
  const isHighSchoolCoach = role === "highschool";
  const isAthlete = role === "athlete";
  const hasSubscriptionAccess = Boolean(
    isPublicView || hasSubscription || isHighSchoolCoach,
  );
  const showFreeTrial =
    !hasSubscriptionAccess && isAthlete && !hasUsedFreeTrial;
  // Upsell UI stays hidden until the subscription check resolves, so a
  // subscribed user never sees the unsubscribed experience flash on mount.
  const canShowUpsell = subscriptionChecked && !hasSubscriptionAccess;

  return {
    authUser,
    user,
    isPublicView,
    isHighSchoolCoach,
    hasSubscription,
    hasUsedFreeTrial,
    hasSubscriptionAccess,
    subscriptionChecked,
    canShowUpsell,
    showFreeTrial,
  };
};
